export const MANS = "МАНСИЙСКИЙ";
export const RUS = "РУССКИЙ";
export const SHORT_MANS = "манс";
export const SHORT_RUS = "рус";
export const WORD_NOT_FINDED_ERROR = "Ошибка: Слово не найдено";
export const TRANSLATOR_MODE = "translator";
export const TABLE_MODE = "table";